type LiveDotStatus = "healthy" | "idle" | "down";

interface LiveDotProps {
  status: LiveDotStatus;
  label?: string;
}

const CLASS_BY_STATUS: Record<LiveDotStatus, string> = {
  healthy: "live-dot live-dot-healthy",
  idle: "live-dot live-dot-idle",
  down: "live-dot live-dot-down",
};

/**
 * A small solid/pulsing dot for binary or tri-state liveness indicators —
 * worker health, connection status, etc. "healthy" pulses (CSS animation
 * in global.css); "idle" and "down" are static.
 */
export function LiveDot({ status, label }: LiveDotProps) {
  return (
    <span
      className={CLASS_BY_STATUS[status]}
      role={label ? "status" : undefined}
      aria-label={label}
      title={label}
    />
  );
}
